import { GraphQL } from '@guestgoodie/graphql'
import { HugeiconsIcon } from '@hugeicons/react'
import { SquareIcon } from '@hugeicons/core-solid-rounded'
import { Trans } from '@lingui/react/macro'

import * as Table from '@/components/ui/Table'

interface Props {
  sortDirection?: GraphQL.SortDirection | null
  sortField?: GraphQL.PromotionsSortField | null
  hideCheckbox: boolean
  onChangeSort: (
    field: GraphQL.PromotionsSortField,
    direction: GraphQL.SortDirection
  ) => void
}

export default function PromotionTableHead({
  sortDirection,
  sortField,
  hideCheckbox,
  onChangeSort
}: Props) {
  return (
    <Table.Head>
      <Table.Row>
        {!hideCheckbox && (
          <Table.Heading>
            <HugeiconsIcon icon={SquareIcon} className="text-white" />
          </Table.Heading>
        )}
        <Table.SortableHeading<GraphQL.PromotionsSortField>
          sortField={GraphQL.PromotionsSortField.Name}
          currentSortDirection={sortDirection}
          currentSortField={sortField}
          onChangeSort={onChangeSort}
        >
          <Trans>Name</Trans>
        </Table.SortableHeading>
        <Table.Heading>Goodie</Table.Heading>
        <Table.SortableHeading<GraphQL.PromotionsSortField>
          sortField={GraphQL.PromotionsSortField.GoodieType}
          currentSortDirection={sortDirection}
          currentSortField={sortField}
          onChangeSort={onChangeSort}
        >
          <Trans>Goodie Type</Trans>
        </Table.SortableHeading>
        <Table.Heading />
      </Table.Row>
    </Table.Head>
  )
}
